'use strict';

exports.__esModule = true;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dropdownMenu = require('./dropdown-menu');

var _dropdownMenu2 = _interopRequireDefault(_dropdownMenu);

var _dropdown = require('../../src/styles/dropdown.scss');

var _dropdown2 = _interopRequireDefault(_dropdown);

var _dropdownItem = require('../../src/styles/dropdown-item.scss');

var _dropdownItem2 = _interopRequireDefault(_dropdownItem);

var _dropdownMenu3 = require('../../src/styles/dropdown-menu.scss');

var _dropdownMenu4 = _interopRequireDefault(_dropdownMenu3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DESKTOP_MIN_WIDTH = 768;

var Dropdown = function (_Component) {
	(0, _inherits3.default)(Dropdown, _Component);

	/******************************** LIFECYCLE ********************************/
	function Dropdown(props) {
		(0, _classCallCheck3.default)(this, Dropdown);

		var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

		_this.handleClickOutside = _this.handleClickOutside.bind(_this);
		_this.enableMouseEnter = _this.enableMouseEnter.bind(_this);

		_this.state = (0, _extends3.default)({
			open: props.open,
			items: props.items,
			selectedItem: props.selectedItem,
			activeItems: []
		}, groupSearchItems(_this.props.items));
		return _this;
	}

	Dropdown.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (this.props.selectedItem !== nextProps.selectedItem) {
			this.inputField.value = this.props.itemDisplayNameTransform(nextProps.selectedItem);
		}
		this.setState((0, _extends3.default)({
			items: nextProps.items
		}, groupSearchItems(nextProps.items)));
	};

	Dropdown.prototype.componentDidUpdate = function componentDidUpdate() {
		var _this2 = this;

		if (window.innerWidth >= DESKTOP_MIN_WIDTH) {
			this.scrollMenuIfOutOfBounds().then(function () {
				_this2.repositionSubMenu();
			});
		}
		if (this.inputField && this.inputField !== this.props.inputField) {
			this.props.setInputField && this.props.setInputField(this.inputField);
		}
	};

	Dropdown.prototype.componentDidMount = function componentDidMount() {
		if (this.props.selectedItem) {
			this.setState({ selectedValue: this.props.itemDisplayNameTransform(this.props.selectedItem) });
			this.inputField.value = this.props.itemDisplayNameTransform(this.props.selectedItem);
		}
		if (this.props.open) {
			this.setState({ open: this.props.open });
			document.addEventListener('click', this.handleClickOutside);
		}
		if (this.inputField && this.inputField !== this.props.inputField) {
			this.props.setInputField && this.props.setInputField(this.inputField);
		}
	};

	/******************************** METHODS ********************************/


	Dropdown.prototype.onItemMouseEnter = function onItemMouseEnter(item, parent, event) {
		// If mouseEnter disabled by keyboard event, return;
		if (this.state.mouseEnterDisabled) {
			return;
		}
		// Look at event to see if it was a mobile tap-to-expand area or a mobile list item.
		if (event.target.className === _dropdownItem2.default.mobileTapArea) {
			return;
		}
		if (event.target.nextElementSibling && event.target.nextElementSibling.className === _dropdownItem2.default.mobileTapArea) {
			return;
		}

		// Callback if exists
		if (this.props.onItemMouseover) {
			this.props.onItemMouseover(item);
		}

		var activeItemCount = this.state.activeItems.length;
		var newActiveItems = this.state.activeItems;

		// No item selected.
		if (activeItemCount === 0) {
			newActiveItems.push(item);
			this.setState({ activeItems: newActiveItems });
			return;
		}

		// If item is the most recently active item...
		if (item === newActiveItems[activeItemCount - 1]) {
			return;
		}

		// If neither of the above, start using active items to recalculate state.
		for (var i = newActiveItems.length - 1; i >= 0; i--) {
			// If the parent of the item is the most recently active item...
			if (parent === newActiveItems[i]) {
				newActiveItems.push(item);
				this.setState({ activeItems: newActiveItems });
				return;
			} else {
				newActiveItems.pop();
			}
		}

		// If this code block is reached, the mouseover event was on one of the top-level
		// items. Clear the array of active items, and add the item to it.
		this.setState({ activeItems: [item] });
	};

	Dropdown.prototype.resetDropdownActive = function resetDropdownActive() {
		this.setState({ activeItems: [] });
	};

	Dropdown.prototype.handleClickOutside = function handleClickOutside(event) {
		// Don't dismiss dropdown if click is on mobile expand area or section header.
		// Needs to be split into nested ifs - don't read properties of null elements.
		if (event.target) {
			if (event.target.className && event.target.className === _dropdownItem2.default.mobileTapArea) {
				return;
			}
			if (event.target.parentElement) {
				if (event.target.parentElement.className && event.target.parentElement.className.includes(_dropdownItem2.default.sectionHeader)) {
					return;
				}
				if (event.target.parentElement.parentElement) {
					if (event.target.parentElement.parentElement.className && event.target.parentElement.parentElement.className.includes(_dropdownItem2.default.sectionHeader)) {
						return;
					}
				}
			}
		}
		this.setState({ open: false });
		this.resetDropdownActive();
		document.removeEventListener('click', this.handleClickOutside);
		if (this.inputField) {
			this.inputField.blur();
		}
	};

	Dropdown.prototype.handleKeyPress = function handleKeyPress(event) {
		var increment = 0;

		// Turn event.key into an increment value, which is later used in indexing the array of children,
		// or used in if blocks for enter/exit submenu behaviour in the case of 11 and -11.
		// Also checks for Esc/Enter and implements corresponding behaviour.
		switch (event.key) {
			case 'ArrowDown':
				increment = 1;
				event.preventDefault();
				break;
			case 'ArrowUp':
				increment = -1;
				event.preventDefault();
				break;
			case 'ArrowRight':
				increment = 11;
				event.preventDefault();
				break;
			case 'ArrowLeft':
				increment = -11;
				event.preventDefault();
				break;
			case 'Escape':
				this.closeDropdown();
				this.inputField.blur();
				return;
			case 'Enter':
				if (this.state.activeItems.length) {
					this.selectItem(this.state.activeItems[this.state.activeItems.length - 1]);
					this.inputField.blur();
					return;
				}
				break;
			default:
				return;
		}

		// Disable mouseEnter events on keypress. This stops odd behaviour
		// if mouse is left over dropdown while using keyboard. Mouse enter is
		// re-enabled on mouse move.
		if (!this.state.mouseEnterDisabled) {
			document.addEventListener('mousemove', this.enableMouseEnter);
		}
		this.setState({ mouseEnterDisabled: true });

		var activeItems = this.state.activeItems;

		// If empty array of active items, activate first one.
		if (!activeItems.length) {
			activeItems.push(this.state.items[0]);
			this.setState({ activeItems: activeItems });
			return;
		}

		var activeElement = activeItems[activeItems.length - 1];

		// If right arrow, select first child of last active element.
		if (increment === 11) {
			if (this.props.itemChildrenTransform(activeElement)) {
				activeItems.push(this.props.itemChildrenTransform(activeElement)[0]);
				this.setState({ activeItems: activeItems });
			}
			return;
		}

		// If left arrow, remove most recently active element.
		if (increment === -11) {
			if (activeItems[activeItems.length - 2] && this.props.itemChildrenTransform(activeItems[activeItems.length - 2])) {
				activeItems.pop();
				this.setState({ activeItems: activeItems });
			}
			return;
		}

		// If length === 1 then don't look at parent because it's root-level
		if (activeItems.length === 1) {
			// Look at the item we're going to activate as a conditional. If it
			// doesn't exist, we don't try and set it as active. (i.e. we can't
			// try and navigate past the last/first items in the list).
			// Additionally, check that the item we're trying to activate is not a section header.
			// If it is, increase the increment.
			while (this.state.items[this.state.items.indexOf(activeItems[0]) + increment] && this.props.isSectionHeaderTransform(this.state.items[this.state.items.indexOf(activeItems[0]) + increment])) {
				// This just 'increments' positively or negatively depending on if increment is + or -
				increment += increment / Math.abs(increment);
			}

			// We leave the while block when we find a non section-header or run out of items.
			// This check is to make sure we have found a non section-header rather than run out of items.
			if (this.state.items[this.state.items.indexOf(activeItems[0]) + increment]) {
				activeItems[0] = this.state.items[this.state.items.indexOf(activeItems[0]) + increment];
				this.setState({ activeItems: activeItems });
			}
			return;
		}

		var parent = activeItems[activeItems.length - 2];

		// If not, look at second-last element of active array, change active element to
		// index-of-last-element-in-array-plus-increment(+ or -) inside its children.
		// First, check the item we're going to activate actually exists, and
		// additionally, check that the item we're trying to activate is not a section header.
		// If it is, increase the increment.
		while (this.props.itemChildrenTransform(parent)[this.props.itemChildrenTransform(parent).indexOf(activeElement) + increment] && this.props.isSectionHeaderTransform(this.props.itemChildrenTransform(parent)[this.props.itemChildrenTransform(parent).indexOf(activeElement) + increment])) {
			// This just 'increments' positively or negatively depending on if increment is + or -
			increment += increment / Math.abs(increment);
		}
		if (this.props.itemChildrenTransform(parent)[this.props.itemChildrenTransform(parent).indexOf(activeElement) + increment]) {
			activeItems[activeItems.length - 1] = this.props.itemChildrenTransform(parent)[this.props.itemChildrenTransform(parent).indexOf(activeElement) + increment];
			this.setState({ activeItems: activeItems });
		}
	};

	Dropdown.prototype.scrollMenuIfOutOfBounds = function scrollMenuIfOutOfBounds() {
		if (!this.state.activeItems.length || !this.state.open) {
			return _promise2.default.resolve();
		}
		var activeElement = document.getElementsByClassName(_dropdownItem2.default.active)[this.state.activeItems.length - 1];

		if (!activeElement) {
			return _promise2.default.resolve();
		}
		var activeElementParent = activeElement.parentElement;

		var elementRect = activeElement.getBoundingClientRect();
		var parentRect = activeElementParent.getBoundingClientRect();

		var scrollInterval = void 0;
		if (elementRect.bottom > parentRect.bottom) {
			return new _promise2.default(function (resolve) {
				scrollInterval = setInterval(function () {
					activeElementParent.scrollTop += 10;
					elementRect = activeElement.getBoundingClientRect();
					parentRect = activeElementParent.getBoundingClientRect();
					if (elementRect.bottom <= parentRect.bottom) {
						clearInterval(scrollInterval);
						resolve();
					}
				}, 10);
			});
		} else if (elementRect.top < parentRect.top) {
			return new _promise2.default(function (resolve) {
				scrollInterval = setInterval(function () {
					activeElementParent.scrollTop -= 10;
					elementRect = activeElement.getBoundingClientRect();
					parentRect = activeElementParent.getBoundingClientRect();
					if (elementRect.top >= parentRect.top) {
						clearInterval(scrollInterval);
						resolve();
					}
				}, 10);
			});
		} else {
			return _promise2.default.resolve();
		}
	};

	Dropdown.prototype.selectItem = function selectItem(selectedItem) {
		this.setState({ selectedValue: this.props.itemDisplayNameTransform(selectedItem) });
		this.props.onItemSelected(selectedItem);
		this.inputField.value = this.props.itemDisplayNameTransform(selectedItem);
		this.closeDropdown();
	};

	Dropdown.prototype.openDropdown = function openDropdown() {
		this.setState({ open: true });
		document.addEventListener('click', this.handleClickOutside);
		this.inputField.focus();
		if (this.props.onOpenDropDown && typeof this.props.onOpenDropDown == "function") {
			this.props.onOpenDropDown();
		}
	};

	Dropdown.prototype.closeDropdown = function closeDropdown() {
		this.setState({ open: false });
		document.removeEventListener('click', this.handleClickOutside);
		this.resetDropdownActive();
	};

	Dropdown.prototype.toggleDropdown = function toggleDropdown() {
		if (this.state.open) {
			this.closeDropdown();
		} else {
			this.openDropdown();
		}
	};

	Dropdown.prototype.repositionSubMenu = function repositionSubMenu() {
		// Step 1. Get current submenu element so we can reposition it.
		var submenuElement = void 0;

		// If we have active item(s) && the most recently active item (ie just moused/keyed over) has children.
		if (this.state.activeItems.length > 0 && this.props.itemChildrenTransform(this.state.activeItems[this.state.activeItems.length - 1])) {
			// Get the nth wrapper (submenu) on the page, where n is the number of active items (and therefore the number of visible submenus)
			submenuElement = document.getElementsByClassName(_dropdownMenu4.default.listWrapper)[this.state.activeItems.length];
		}

		// Only try and reposition element if it exists.
		if (submenuElement) {

			// Step 2. Get the li tag that is the parent of the submenu element. This will be used to reposition.
			var submenuElementLiParent = submenuElement.parentElement;

			// Step 3. Get the ul tag that is the parent of the submenu's parent. Used to calculate scroll offset.
			var submenuElementUlParent = submenuElementLiParent.parentElement;

			// Step 4. Position the submenu element.

			var childListUl = submenuElement.getElementsByTagName('ul')[0];

			//if showing expanded dropdown and they are already being showed, reset styles
			// if (this.props.showExpandedDropdown === true && (
			// 		this.state.specialistsAndPracticesItems.length > 0 ||
			// 		this.state.specialtiesItems.length > 0 ||
			// 		this.state.conditionsAndProceduresItems.length > 0)
			// ) {
			// 	submenuElement.style.removeProperty('top');
			// 	submenuElement.style.removeProperty('left');
			// 	submenuElement.style.removeProperty('visibility');
			// 	childListUl.style.removeProperty('width');
			// } else {
			submenuElement.style.top = submenuElementLiParent.offsetTop - submenuElementUlParent.scrollTop + 'px';
			submenuElement.style.left = submenuElementLiParent.clientWidth + 'px';
			submenuElement.style.visibility = 'visible';

			childListUl.style.width = submenuElementLiParent.clientWidth + 10 + 'px';
			// }
		}
	};

	Dropdown.prototype.toggleMobileSubmenu = function toggleMobileSubmenu(selectedItem) {
		var newActiveItems = this.state.activeItems;
		if (newActiveItems.includes(selectedItem)) {
			// Maybe remove all children as well? Recursive function - if child of selected item in activeItems, call function on it. Base case === item has no children in activeItems.
			newActiveItems.splice(newActiveItems.indexOf(selectedItem), 1);
		} else {
			newActiveItems.push(selectedItem);
		}
		this.setState({ activeItems: newActiveItems });
	};

	Dropdown.prototype.enableMouseEnter = function enableMouseEnter() {
		this.setState({ mouseEnterDisabled: false });
		document.removeEventListener('mousemove', this.enableMouseEnter);
	};

	/******************************** RENDER ********************************/


	Dropdown.prototype.render = function render() {
		var _this3 = this;

		return _react2.default.createElement(
			'div',
			{ id: this.props.id, className: _dropdown2.default.dropdownTopLevel + ' ' + this.props.className },
			_react2.default.createElement(
				'div',
				{ className: '' + _dropdown2.default.inputArea },
				_react2.default.createElement(
					'div',
					{ onClick: function onClick() {
							_this3.toggleDropdown();
						} },
					_react2.default.createElement(this.props.ContentRenderer, null)
				),
				_react2.default.createElement('input', {
					ref: function ref(input) {
						_this3.inputField = input;
					},
					id: this.props.id + 'Input',
					className: '' + _dropdown2.default.dropdown,
					placeholder: this.props.placeholder,
					type: 'text',
					autoComplete: 'off',
					readOnly: this.props.readonly,
					tabIndex: this.props.tabIndex,
					onChange: function onChange(event) {
						if (!_this3.state.open) {
							_this3.setState({ open: true });
						}
						_this3.props.onTextChanged(event.target.value);
					},
					onClick: function onClick() {
						_this3.toggleDropdown();
					},
					onKeyDown: function onKeyDown(event) {
						_this3.handleKeyPress(event);
					},
					onFocus: function onFocus(event) {
						_this3.props.onReceiveFocus(event);
					},
					style: this.props.width ? { 'width': this.props.width } : {}
				})
			),
			this.props.hint && _react2.default.createElement(
				'div',
				{ className: _dropdown2.default['dropdown-hint'] + ' ' + (this.state.open && _dropdown2.default.show + ' ' + _dropdown2.default['dropdown-hint_translated'] || '') },
				this.props.hint
			),
			_react2.default.createElement(
				'div',
				{ className: (this.state.open ? '-show' : _dropdown2.default.hide) + ' ' + _dropdown2.default.dropdownList + ' ' + (this.props.showExpandedDropdown === true && _dropdown2.default['dropdown-list_expanded'] || '') },
				this.state.open && this.props.showExpandedDropdown && _react2.default.createElement('span', {className: (_dropdown2.default.promtForPatients) }, 'Before undergoing any private treatment for which you wish to make a claim under your plan, you must gain written pre-authorization.' ),
				this.state.open && _react2.default.createElement(_dropdownMenu2.default, {
					items: this.state.items,
					showExpandedDropdown: this.props.showExpandedDropdown,
					topLevelSpecialtiesItems: this.state.topLevelSpecialtiesItems,
					subSpecialtiesItems: this.state.subSpecialtiesItems,
					specialistsItems: this.state.specialistsItems,
					onItemClick: function onItemClick(selectedItem) {
						_this3.selectItem(selectedItem);
					},
					toggleMobileSubmenu: function toggleMobileSubmenu(selectedItem) {
						_this3.toggleMobileSubmenu(selectedItem);
					},
					onItemMouseEnter: function onItemMouseEnter(item, parent, event) {
						_this3.onItemMouseEnter(item, parent, event);
					},
					isActive: function isActive(item) {
						return _this3.state.activeItems.includes(item);
					},
					itemDisplayNameTransform: this.props.itemDisplayNameTransform,
					itemChildrenTransform: this.props.itemChildrenTransform,
					isSectionHeaderTransform: this.props.isSectionHeaderTransform,
					ItemRenderer: this.props.ItemRenderer,
					SectionHeaderRenderer: this.props.SectionHeaderRenderer,
					mobile: window.innerWidth < DESKTOP_MIN_WIDTH })
			)
		);
	};

	return Dropdown;
}(_react.Component);

/******************************** DEFAULTS & EXPORTS ********************************/


Dropdown.displayName = 'Dropdown';

Dropdown.defaultProps = {
	className: '',
	readonly: false,
	open: false,
	items: [],
	placeholder: 'Enter a keyword',
	onItemSelected: function onItemSelected() {},
	onReceiveFocus: function onReceiveFocus() {},
	onTextChanged: function onTextChanged(value) {
		if (value === '') {
			return [];
		}
		return [{ id: value, name: value }];
	},
	id: 'TestDropdown',
	ContentRenderer: function ContentRenderer() {
		return _react2.default.createElement(
			'div',
			{ className: _dropdown2.default.defaultContentRenderer },
			_react2.default.createElement('i', { className: 'ion-android-arrow-dropdown' })
		);
	},
	itemDisplayNameTransform: function itemDisplayNameTransform(item) {
		return item && item.name || '';
	},
	itemChildrenTransform: function itemChildrenTransform(item) {
		return item.children;
	},
	isSectionHeaderTransform: function isSectionHeaderTransform(item) {
		return item.isSectionHeader;
	},
	ItemRenderer: function ItemRenderer(props) {
		var item = props.item,
		    nameTransform = props.nameTransform,
		    childrenTransform = props.childrenTransform;

		return _react2.default.createElement(
			'div',
			{ className: _dropdown2.default.defaultItemRenderer },
			_react2.default.createElement(
				'span',
				null,
				nameTransform(item)
			),
			_react2.default.createElement('i', { className: (childrenTransform(item) ? 'ion-ios-arrow-right' : '') + ' ' + _dropdown2.default.parentIconDesktop }),
			_react2.default.createElement('i', { className: (childrenTransform(item) ? 'ion-ios-arrow-down' : '') + ' ' + _dropdown2.default.parentIconMobile })
		);
	},
	SectionHeaderRenderer: function SectionHeaderRenderer(props) {
		var item = props.item,
		    nameTransform = props.nameTransform;

		return _react2.default.createElement(
			'div',
			{ className: _dropdownItem2.default.defaultSectionHeader },
			_react2.default.createElement(
				'span',
				null,
				nameTransform(item)
			)
		);
	},

	showExpandedDropdown: false
};

exports.default = Dropdown;


var groupSearchItems = function groupSearchItems(items) {
	//remove children and children_have_specialists because we don't want submenus to appear in expanded dropdown
	var removeChildren = function removeChildren(item) {
		return (0, _extends3.default)({}, item, {
			children: undefined,
			children_have_specialists: undefined
		});
	};

	var topLevelSpecialtiesItems = items.filter(function (item) {
		return item.type === 'specialty';
	}).map(removeChildren);
	var subSpecialtiesItems = items.filter(function (item) {
		return (item.type === 'condition' || item.type === 'procedure');
	}).map(removeChildren).slice(0, 10);
	var specialistsItems = items.filter(function (item) {
		return item.type === 'specialist';
	});

	if (topLevelSpecialtiesItems.length > 0 || subSpecialtiesItems.length > 0 || specialistsItems.length > 0) {
		return {
			topLevelSpecialtiesItems: topLevelSpecialtiesItems.length && topLevelSpecialtiesItems || [{ name: 'No Results Found' }],
			subSpecialtiesItems: subSpecialtiesItems.length && subSpecialtiesItems || [{ name: 'No Results Found' }],
			specialistsItems: specialistsItems.length && specialistsItems || [{ name: 'No Results Found' }]
		};
	} else {
		return {
			topLevelSpecialtiesItems: [],
			subSpecialtiesItems: [],
			specialistsItems: []
		};
	}
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/dropdown/lib/components/dropdown.js
// module id = 1462
// module chunks = 0